import React from "react";

export default function OptionalLabel(props) {
  const text = props.text || "";
  const to = props.htmlFor || "";
  const showRefresh = props.showRefresh || false;
  const onclickAction = props.onclickAction || "";
  const loaded = props.loaded || false;
  const className = props.className || "waveLabel";
  return (
    <label htmlFor={to} className={className}>
      {showRefresh ? (
        <>
          <button
            className="linkBtn text-dark"
            style={{ lineHeight: 0 }}
            onClick={onclickAction}
          >
            <i className="fa fa-refresh"></i>
          </button>
        </>
      ) : (
        ""
      )}
      {text} <span className="optional">[Optional]</span>
      {!loaded && showRefresh ? <i className="fa fa-spinner"></i> : ""}{" "}
    </label>
  );
}
